import React from 'react';
import { SectionHeading } from './SectionHeading';
import { CTAButton } from './CTAButton';
import { modules } from '../data/content';
export function ModulesSection() {
  return <section className="bg-cream px-4 py-6 sm:px-6" data-id="element-120" data-mp="1ivl1y16i72pk">
      <SectionHeading size="lg" data-id="element-121" data-mp="1iw32vb44253t">What’s inside</SectionHeading>

      <div className="mx-auto mt-4 max-w-2xl space-y-2.5" data-id="element-122" data-mp="1dx076ha0tb8i">
        {modules.map(module => <article key={module.number} className="overflow-hidden rounded-md border border-navy/15 bg-white shadow-sm" data-id="element-123" data-mp="2bks89mc78wld">
            <header className="flex items-center gap-2 px-3 py-2" style={{
          backgroundColor: module.color
        }} data-id="element-124" data-mp="26j2va15f28un">
              <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded bg-white/20 font-body text-[11px] font-extrabold text-white" data-id="element-125" data-mp="1wnrdf9ypolio">
                {module.number}
              </span>
              <h3 className="font-heading text-[13px] font-extrabold uppercase leading-tight text-white sm:text-base" data-id="element-126" data-mp="l6romobkoote">
                ✅ Module {module.number} — {module.title}
              </h3>
            </header>

            <div className="p-3" data-id="element-127" data-mp="1nt0fuj8ld14g">
              <p className="text-[12px] font-semibold leading-snug text-graphite sm:text-[13px]" data-id="element-128" data-mp="1nrz5kgzegins">
                {module.intro}
              </p>

              <p className="mt-2 text-[12px] font-bold leading-snug text-navy sm:text-[13px]" data-id="element-129" data-mp="1dv4a66yfaydq">
                {module.listIntro}
              </p>
              <ul className="mt-1.5 flex flex-wrap gap-1" data-id="element-130" data-mp="102wgio2frnj9">
                {module.items.map(item => <li key={item} className="rounded bg-cream px-2 py-0.5 text-[11px] font-semibold text-graphite" data-id="element-131" data-mp="q6l1vrfdilln">
                    {item}
                  </li>)}
              </ul>

              {module.after.map(line => <p key={line} className="mt-2 text-[12px] font-medium leading-snug text-graphite sm:text-[13px]" data-id="element-132" data-mp="l7gpyt12e9rm">
                  {line}
                </p>)}

              {module.questions && <ul className="mt-2 flex flex-wrap gap-1" data-id="element-133" data-mp="2j241artlekcp">
                  {module.questions.map(question => <li key={question} className="rounded border border-teal/40 bg-teal/10 px-2 py-0.5 text-[11px] font-semibold text-teal" data-id="element-134" data-mp="2e1zk0zkv1llf">
                      {question}
                    </li>)}
                </ul>}

              <p className="mt-2 border-t border-cream-deep pt-2 text-[12px] font-extrabold uppercase tracking-wide text-terracotta" data-id="element-135" data-mp="2wuk2ro6uiabi">
                {module.tag}
              </p>
            </div>
          </article>)}
      </div>

      <div className="mx-auto mt-4 max-w-md" data-id="element-136" data-mp="1lggacmfwou8k">
        <CTAButton data-id="element-137" data-mp="1he331tligo9o">👥 Yes! I want the complete system</CTAButton>
      </div>
    </section>;
}